'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/** Blatantly stolen from aphrodite */

var UPPERCASE_RE = /([A-Z])/g;
var MS_RE = /^ms-/;

var kebabify = function kebabify(string) {
  return string.replace(UPPERCASE_RE, '-$1').toLowerCase();
};
var kebabifyStyleName = function kebabifyStyleName(string) {
  return kebabify(string).replace(MS_RE, '-ms-');
};
exports.default = kebabifyStyleName;


//////////////////
// WEBPACK FOOTER
// ./~/narcissus/build/kebabifyStyleName.js
// module id = 3199
// module chunks = 0